import { IMAGE_TYPES_MAP, trackingEvent } from '../../../constants'
import activityTrackingService from '../../../services/activityTrackingService'

const isFactsheetHavingFactsAssignedToRooms = facts => {
  return Object.values(facts ?? []).some(
    factInstances => factInstances.some(instance => instance.appliesTo?.length > 0)
  )
}

const isRoomHavingBothExpediaAndBookingCodes = room => {
  return room.details?.some(detail =>
    detail.codes?.some(code => code.id === 'booking') &&
    detail.codes?.some(code => code.id === 'expedia')
  )
}

const isAllRoomsHaveAtLeastOneImage = (images, rooms, galleries) => {
  if (rooms.length === 0) {
    return false
  }
  return rooms.every(room => galleries?.rooms?.[room.id]?.order?.length > 0)
}

const trackMotifTypeChange = (code, isRoomImage) => {
  const label = IMAGE_TYPES_MAP.has(code) ? IMAGE_TYPES_MAP.get(code).label : ''
  activityTrackingService.trackEvent(
    trackingEvent.selectMotifType,
    { name: label, imageType: isRoomImage ? 'room' : 'property' }
  )
}

const isUploadQueueActive = (uploadQueue) => {
  // checks if any upload is in progress
  // only 0 and 1 indicate waiting / uploading
  return uploadQueue.length > 0 && uploadQueue.some(uploadItem => uploadItem.status < 2)
}

export {
  isFactsheetHavingFactsAssignedToRooms,
  isRoomHavingBothExpediaAndBookingCodes,
  isAllRoomsHaveAtLeastOneImage,
  trackMotifTypeChange,
  isUploadQueueActive,
}
